import React from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'antd'
import './editButton.css';

export const EditButton = ({link, className}) => (
  <Link className={ className || "edit-button" } to={link}>
    Edit
    <Icon type="edit" className="edit-button__icon" />
  </Link>
);



// WEBPACK FOOTER //
// ./src/components/common/editButton/editButton.js